import { render, staticRenderFns } from "./DetalleFacturaPage.vue?vue&type=template&id=6493cd93"
import script from "./DetalleFacturaPage.js?vue&type=script&lang=js&external"
export * from "./DetalleFacturaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports